import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export function PresentationalWrapper(props) {
    return _jsx("div", Object.assign({ role: "presentation" }, { children: props.children }));
}
//# sourceMappingURL=PresentationalWrapper.js.map